import React, { Component } from "react";
import { Button, Card } from "reactstrap";

class CommentCard extends Component {
  render() {
    return (
      <Card className="comment padded">
        <blockquote className="blockquote">
          {this.props.comment.text}
        </blockquote>
        <div className="row">
          <div className="offset-md-6 col-md-6">
            <div className="pull-right">
              <Button
                color="link"
                size="sm"
                onClick={() => this.props.onInappropriate(this.props.comment)}
              >
                inapropiado
              </Button>
              <Button
                className="vote-btn"
                size="sm"
                color="success"
                disabled={!this.props.canUpvote}
                onClick={() => this.props.onUpvote(this.props.comment)}
              >
                <i className="fa fa-thumbs-up" aria-hidden="true" />
                {" " + this.props.comment.upvotes}
              </Button>
              <Button
                className="vote-btn"
                size="sm"
                color="danger"
                disabled={!this.props.canDownvote}
                onClick={() => this.props.onDownvote(this.props.comment)}
              >
                <i className="fa fa-thumbs-down" aria-hidden="true" />
                {" " + this.props.comment.downvotes}
              </Button>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

export default CommentCard;



// WEBPACK FOOTER //
// ./src/components/CommentCard.js